import { Fade, Grid } from "@mui/material";
import { useContext } from "react";
import Config from "../../services/config";
import ClearFilters from "../ClearFilters/ClearFilters";
import { DataViewContext } from "../DataViewProvider/DataViewProvider";
import FileTypeFilter from "../FileTypeFilter/FileTypeFilter";
import Search from "../Search/Search";
import styles from './ResourcesFilters.module.scss';

export default function ResourcesFilters() {
    const context = useContext(DataViewContext)
    return (
        <Fade in={!context.loading} timeout={Config.DEFAULT_FADE_TIMEOUT}>
            <Grid container justifyContent="flex-start" alignItems="center" className={styles.ResourcesFilters}>
                <Search value={context.filters.name} onChange={context.setFilter} name="name" />
                <FileTypeFilter value={context.filters.fileType} onChange={context.setFilter} multiple={true} />
                <div style={{ marginLeft: 20 }}></div>
                <ClearFilters />
            </Grid>
        </Fade>
    )
}
